import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CategoryEntity } from './category.entity';
import { PriceContractEntity } from './price-contract.entity';

@Index('fk_category__id', ['fkCategoryId'], {})
@Index('fk_price_contract__id', ['fkPriceContractId'], {})
@Index(
	'price_contract_category_item_constraint',
	['fkPriceContractId', 'fkCategoryId', 'startDate', 'endDate'],
	{},
)
@Entity('price_contract_category_item')
export class PriceContractCategoryItemEntity extends BaseEntity {
	@Column('int', { name: 'fk_price_contract__id', unsigned: true })
	public fkPriceContractId!: number;

	@Column('int', { name: 'fk_category__id', unsigned: true })
	public fkCategoryId!: number;

	@Column('date', { name: 'startDate', nullable: true })
	public startDate!: string | null;

	@Column('date', { name: 'endDate', nullable: true })
	public endDate!: string | null;

	@Column('varchar', { name: 'priceType', length: 32 })
	public priceType!: string;

	@Column('varchar', { name: 'priceSource', nullable: true, length: 255 })
	public priceSource!: string | null;

	@Column('decimal', {
		name: 'priceValue',
		nullable: true,
		precision: 15,
		scale: 6,
	})
	public priceValue!: string | null;

	@Column('int', { name: 'priority', unsigned: true, default: () => "'0'" })
	public priority!: number;

	@ManyToOne(
		() => CategoryEntity,
		(category) => category.priceContractCategoryItems,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk_category__id', referencedColumnName: 'id' }])
	public category!: CategoryEntity;

	@ManyToOne(
		() => PriceContractEntity,
		(priceContract) => priceContract.priceContractCategoryItems,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk_price_contract__id', referencedColumnName: 'id' }])
	public priceContract!: PriceContractEntity;
}
